/**
 * useCart
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CartContext from './cart-context'

const useCart = () => {
  const context = useContext(CartContext)
  return context
}

export default useCart
